module.exports = __webpack_public_path__ + "png/roulette-win.png?493322d9abc560e6131c3c1a481be1ed";